<template>
    <div>
        <div class="flex flex-col min-h-[90px] rounded-md border border-gray-300 bg-white">
            <div class="flex flex-1 items-center justify-between p-4">
                <p
                    class="text-[14px] sm:text-[16px] font-semibold text-[#141430]"
                >
                    <slot name="title" />
                </p>

                <button
                    @click="expanded = !expanded"
                    class="flex justify-center items-center ml-4 h-[28px] w-[28px] shrink-0 rounded-full border bg-[#399ADB]"
                >
                    <img
                        v-if="!expanded"
                        src="/images/campaigns/plus-sign.svg"
                        alt="Plus sing icon"
                    />

                    <img
                        v-else
                        src="/images/campaigns/minus-sign.svg"
                        class="w-[10px]"
                        alt="Minus sing icon"
                    />
                </button>
            </div>

            <div
                    v-if="expanded"
                    class="text-[14px] p-4 text-[#33334F] duration-150 mr-[35px]"
                >
                    <slot />
                </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            expanded: false,
        };
    },
};
</script>
